function initFaqs(list) {
	if (list.dataset.faqsInit === "true") {
		return;
	}

	const items = list.querySelectorAll(".faq-item");
	if (!items.length) {
		return;
	}

	list.dataset.faqsInit = "true";

	items.forEach((item) => {
		item.addEventListener("toggle", () => {
			if (!item.open) {
				return;
			}

			items.forEach((other) => {
				if (other !== item) {
					other.open = false;
				}
			});
		});
	});
}

function bootFaqs() {
	document.querySelectorAll("[data-faqs]").forEach((list) => initFaqs(list));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootFaqs);
} else {
	bootFaqs();
}
